import React, { SVGAttributes } from 'react';
import { motion, MotionProps } from 'framer-motion';
import { IconButton, IconButtonProps } from '@mui/material';

const Path = (props: MotionProps & SVGAttributes<unknown>) => (
  <motion.path
    initial={false}
    fill="transparent"
    strokeWidth="3"
    stroke="hsl(0, 0%, 18%)"
    strokeLinecap="round"
    {...props}
  />
);

const transition = {
  delay: 0.2
};

const ToggleIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    style={{
      position: 'relative',
      top: 2,
      left: 2
    }}
  >
    <Path
      transition={transition}
      variants={{
        closed: { d: 'M 2 2.5 L 20 2.5' },
        open: { d: 'M 3 16.5 L 17 2.5' }
      }}
    />
    <Path
      d="M 2 9.423 L 20 9.423"
      variants={{
        closed: { opacity: 1 },
        open: { opacity: 0 }
      }}
      transition={{ duration: 0.1, ...transition }}
    />
    <Path
      transition={transition}
      variants={{
        closed: { d: 'M 2 16.346 L 20 16.346' },
        open: { d: 'M 3 2.5 L 17 16.346' }
      }}
    />
  </svg>
);

export const NavToggle = ({ onClick, ...props }: IconButtonProps) => (
  <IconButton onClick={onClick} {...props}>
    <ToggleIcon />
  </IconButton>
);
